import React, { useMemo, useState } from "react";
import { Table } from "antd";
import { IMyTradeTransaction } from "./IMyTradeTransaction";
import { getMyTradeColumns } from "./const";
import SecondaryMarketService from "@services/SecondaryMarket.service";
import { useMediaQuery } from "react-responsive";
import { DESKTOP_WIDTH } from "@bundles/consts";
import { MyTradeMobileExpandedRow } from "./MyTradeMobileExpandedRow";

type MyTradesListProps = {
  trades: IMyTradeTransaction[];
};

export const MyTradesList = ({ trades }: MyTradesListProps) => {
  const isMobile = useMediaQuery({ maxWidth: DESKTOP_WIDTH });
  const [expandedRowKeys, setExpandedRowKeys] = useState<React.Key[]>([]);

  const getAgreement = (tradeId: number) => {
    const windowReference = window.open();
    SecondaryMarketService.getAgreement(tradeId).then((resp) => {
      if (windowReference) {
        windowReference.location = resp.data.url;
      }
    });
  };

  const handleExpandToggle = (record: IMyTradeTransaction) => {
    setExpandedRowKeys((prev) =>
      prev.includes(record.id)
        ? prev.filter((id) => id !== record.id)
        : [...prev, record.id]
    );
  };

  const myTradeColumns = useMemo(
    () =>
      getMyTradeColumns({
        getAgreement,
        isMobile,
        handleExpandToggle,
        expandedRowKeys,
      }),
    [getAgreement, isMobile, handleExpandToggle, expandedRowKeys]
  );

  return (
    <Table
      className="tailwind-table-white"
      columns={myTradeColumns}
      dataSource={trades}
      pagination={false}
      rowKey="id"
      expandable={
        isMobile
          ? {
              expandedRowKeys,
              defaultExpandAllRows: false,
              showExpandColumn: false,
              expandedRowClassName: () => "bg-grey-light",
              expandedRowRender: (record) => (
                <MyTradeMobileExpandedRow
                  trade={record}
                  onAgreementClick={getAgreement}
                />
              ),
            }
          : undefined
      }
    />
  );
};
